import * as React from 'react';
import { useBgColorCtx } from '~theme/BgColorProvider';

/**
 * no-JSX component that will set the closest BgColorProvider value
 * as document.body background
 */
export var SetBodyBgColor = function SetBodyBgColor() {
  var _useBgColorCtx = useBgColorCtx(),
      bgColorValue = _useBgColorCtx.bgColorValue;

  React.useEffect(function () {
    document.body.style.background = bgColorValue;
  }, [bgColorValue]);
  return null;
};